"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = exports.ProductItem = exports.ShoppingCartIndicator = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const drawer_1 = require("@react-navigation/drawer");
const theme_1 = require("theme");
const modal_1 = require("components/modal");
const MyShoppingCart_1 = require("components/partial/MyShoppingCart");
const Clients_1 = require("components/partial/Clients");
const hooks_1 = require("components/hooks");
const services_1 = require("services");
const constants_1 = require("constants/constants");
const url_1 = require("utils/url");
const context_1 = require("components/context");
const icons_1 = __importDefault(require("constants/icons"));
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const native_1 = require("@react-navigation/native");
const OrdersPartial = ({ navigation }) => {
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        return () => {
            setQuery("");
        };
    }, []));
    React.useEffect(() => {
        const validateClientExists = async () => {
            const cli = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
            if (cli == null)
                navigation.navigate(Clients_1.name, {});
        };
        validateClientExists();
    });
    const authContext = React.useContext(context_1.AuthContext);
    const client = (0, hooks_1.useClient)();
    const [warehouse, setWarehouse] = React.useState(undefined);
    const timeoutID = React.useRef(null);
    const [query, setQuery] = React.useState("");
    const onQueryChange = (query) => {
        clearTimeout(timeoutID.current);
        const id = setTimeout(() => {
            setQuery(query);
        }, 800);
        timeoutID.current = id;
    };
    const [fullSrcreenIsLoading, fullScreenSetLoading] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const blockRequest = React.useRef(false);
    const lastPage = React.useRef(0);
    const [products, setProducts] = React.useState(undefined);
    const listProducts = async () => {
        if (client == null || !warehouse?.codigo) {
            setProducts(undefined);
            return;
        }
        setCurrentPage(1);
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            setProducts(undefined);
            setProducts(response?.data);
            shoppingCartList();
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, services_1.doCatalogo)({
            params: {
                q: query,
                almacen: warehouse?.codigo || "",
                page: 1,
            },
            callback: {
                onSuccess: onSuccess,
                onLoading: setLoading,
                onFailSessionExpired,
            },
        });
    };
    const loadMoreProducts = () => {
        let nextPage = currentPage + 1;
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            if (response?.data?.length ?? 0 > 0) {
                setProducts(products => {
                    let prods = [...(products ?? []), ...(response?.data ?? [])];
                    console.error(prods);
                    return prods;
                });
                setLoading(false);
                setCurrentPage(nextPage);
            }
            blockRequest.current = false;
        };
        const onFail = () => {
            blockRequest.current = false;
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, services_1.doCatalogo)({
            params: {
                q: query,
                almacen: warehouse?.codigo || "",
                page: nextPage,
            },
            callback: {
                onSuccess: onSuccess,
                onFail,
                onLoading: setLoading,
                onFailSessionExpired,
            },
        });
    };
    React.useEffect(() => {
        listProducts();
    }, [warehouse?.codigo, query]);
    const shoppingCartIdentity = React.useRef("texto-cualquiera");
    const [shoppingCartSize, setShoppingCartSize] = React.useState("0");
    const shoppingCartList = async () => {
        const onSuccess = (response) => {
            setShoppingCartSize(response.data?.length?.toString() ?? "0");
        };
        (0, services_1.doCarritoList)({
            callback: {
                onSuccess: onSuccess,
            },
        });
    };
    const addProduct = React.useCallback((product, size) => {
        const onSuccess = () => {
            shoppingCartList();
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, services_1.doCarritoAdd)({
            params: {
                data: {
                    procodigo: product.codigo,
                    cantidad: size,
                    stockAlert: product.stockAlert,
                    stockAlertFecha: product.stockAlertFecha,
                    stockAlertReason: product.stockAlertReason,
                    stockAlertReasonType: product.stockAlertReasonType,
                    stockAlertColor: product.stockAlertColor,
                },
            },
            callback: {
                onSuccess: onSuccess,
                onFailSessionExpired,
                onLoading: fullScreenSetLoading,
            },
        });
    }, []);
    const removeProduct = React.useCallback((product) => {
        const onSuccess = () => {
            //route.params?.updateProducts?.();
            shoppingCartList();
        };
        (0, services_1.doCarritoRemove)({
            params: {
                data: {
                    procodigo: product?.codigo,
                },
            },
            callback: {
                onSuccess: onSuccess,
                onLoading: fullScreenSetLoading,
            },
        });
    }, []);
    const renderItem = ({ index, item }) => (<exports.ProductItem first={index === 0} withBottomLine product={item} addProduct={addProduct} removeProduct={removeProduct}/>);
    if (client == null) {
        return <></>;
    }
    return (<>
			<native_base_1.VStack h="100%">
				<Header onShoppingCartClick={() => {
            navigation.navigate(MyShoppingCart_1.name, {
                /*updateProducts: () => {
                    listProducts();
                    shoppingCartList();
                },*/
                warehouseCode: warehouse?.codigo,
                quoteClientId: undefined,
            });
        }} onSelectWarehouse={(warehouse) => {
            setWarehouse(currentWh => {
                if (currentWh?.codigo != warehouse?.codigo)
                    setProducts(undefined);
                return warehouse;
            });
        }} onEmptyWarehouse={() => {
            setProducts(undefined);
        }} onQueryChange={onQueryChange} shoppingCartList={shoppingCartList} shoppingCartSize={shoppingCartSize} onShoppingCartCleared={() => {
            shoppingCartIdentity.current = (Math.random() + 1).toString(36).substring(7);
            listProducts();
            shoppingCartList();
        }}/>
				<native_base_1.FlatList key={`${query}${shoppingCartIdentity.current}`} data={products} extraData={query} renderItem={renderItem} ListFooterComponent={() => (<native_base_1.View style={{ marginBottom: 300 }}>{isLoading && <native_base_1.Spinner size="lg" color="black"/>}</native_base_1.View>)} onScroll={e => {
            let paddingToBottom = 3000;
            paddingToBottom += e.nativeEvent.layoutMeasurement.height;
            var currentOffset = e.nativeEvent.contentOffset.y;
            var direction = currentOffset > 999999999999 ? "down" : "up";
            if (direction === "up") {
                if (e.nativeEvent.contentOffset.y >= e.nativeEvent.contentSize.height - paddingToBottom) {
                    if (!isLoading && currentPage < lastPage.current && !blockRequest.current) {
                        blockRequest.current = true;
                        setTimeout(() => {
                            loadMoreProducts();
                        }, 10);
                    }
                }
            }
        }} flex="1"/>
			</native_base_1.VStack>
			<BannerModal />
			<DeudaModal />
			<FullScreenLoad_1.default isVisible={fullSrcreenIsLoading}/>
		</>);
};
const Header = (props) => {
    const { onShoppingCartClick, shoppingCartSize, onSelectWarehouse, onEmptyWarehouse, onQueryChange, onShoppingCartCleared, } = props;
    const [isSmallWidth] = (0, native_base_1.useMediaQuery)({
        maxWidth: 992,
    });
    const clearShoppingCart = () => {
        const onSuccess = () => {
            onShoppingCartCleared();
        };
        (0, services_1.doCarritoClear)({
            params: {},
            callback: {
                onSuccess: onSuccess,
            },
        });
    };
    return (<native_base_1.View style={{
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
        }} justifyContent="flex-end" px={{
            base: 20,
            md: 40,
            lg: 70,
        }} mt={{
            base: 15,
            md: 20,
            lg: 30,
        }}>
			<Warehouse onSelectWarehouse={onSelectWarehouse} onEmptyWarehouse={onEmptyWarehouse}/>

			<SearchProduct onQueryChange={onQueryChange}/>

			<exports.ShoppingCartIndicator onShoppingCartClick={onShoppingCartClick} onClearShoppingCartPress={clearShoppingCart} shoppingCartSize={shoppingCartSize} mt={{
            base: 10,
            xl: 0,
        }}/>
		</native_base_1.View>);
};
const Warehouse = ({ onSelectWarehouse, onEmptyWarehouse }) => {
    const modalRef = React.createRef();
    const isDrawerOpen = (0, drawer_1.useDrawerStatus)() === "open";
    const [warehouse, setWarehouse] = React.useState("");
    const [showModal, setShowModal] = React.useState(false);
    const onPress = () => {
        //navigation.closeDrawer();
        //navigation.openDrawer();
        //navigation.setParams({});
        modalRef.current?.onOpen();
        setShowModal(true);
    };
    return (<>
			<modal_1.ModalSelectWarehouse onConfirmPress={warehouse => {
            onSelectWarehouse(warehouse);
            setShowModal(false);
            setWarehouse(warehouse?.nombre || "");
        }} onFirstOrSelectedWarehouseObtained={warehouse => {
            onSelectWarehouse(warehouse);
            setWarehouse(warehouse?.nombre || "");
        }} onEmptyWarehouse={() => {
            onEmptyWarehouse();
            setShowModal(true);
        }} isOpen={showModal} onClose={() => setShowModal(false)} ref={modalRef}/>
			<native_base_1.View style={{
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
        }} minW={{ base: "100%", xl: "auto" }}>
				<react_native_1.TouchableOpacity style={stockStyles.container} onPress={onPress}>
					<native_base_1.Text variant="h3" flex="1">
						{warehouse}
					</native_base_1.Text>
					<native_base_1.Image style={stockStyles.imgMore} source={require("images/ic_more.svg")} alt="more icon"/>
				</react_native_1.TouchableOpacity>
				<native_base_1.Image source={require("images/ic_filter.svg")} style={{
            width: 30,
            height: 30,
        }} alt="filter icon"/>
			</native_base_1.View>
		</>);
};
const SearchProduct = (props) => {
    const { onQueryChange } = props;
    const [query, setQuery] = React.useState("");
    const handleChange = (event) => {
        onQueryChange(event.target.value);
        setQuery(event.target.value);
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        return () => {
            setQuery("");
        };
    }, []));
    return (<native_base_1.Input placeholder={theme_1.Str.searchProduct} minW={{ base: "100%", md: 230 }} px="10" flex="1" ml={{ base: 0, xl: 20 }} mr={{ base: 0, lg: 0 }} mt={{ base: 10, xl: 0 }} borderColor="white" borderRadius="40" value={query} onChange={handleChange} InputRightElement={<native_base_1.Image source={require("images/ic_search.svg")} variant="iconInputRight" alt="search icon"/>}/>);
};
const ShoppingCartIndicator = props => {
    const { onShoppingCartClick, onClearShoppingCartPress, shoppingCartSize, ...rest } = props;
    return (<native_base_1.View flexDirection="row" alignItems="center" {...rest}>
			{(Number(shoppingCartSize) ?? 0) > 0 && (<native_base_1.Pressable onPress={onClearShoppingCartPress} mx="10">
					<native_base_1.Tooltip label={theme_1.Str.emptyCart} openDelay={500}>
						<native_base_1.View style={{
                backgroundColor: "black",
                borderRadius: theme_1.Sizes.configRadius,
                padding: 10,
                marginTop: 1,
            }}>
							<native_base_1.Image source={icons_1.default.icShoppingCartClear} w={{
                base: 21,
                md: 35,
            }} h={{
                base: 21,
                md: 35,
            }} alt="shopping cart"/>
						</native_base_1.View>
					</native_base_1.Tooltip>
				</native_base_1.Pressable>)}

			<react_native_1.TouchableOpacity onPress={onShoppingCartClick}>
				<native_base_1.View style={{
            backgroundColor: "black",
            borderRadius: theme_1.Sizes.configRadius,
            padding: 10,
            marginTop: 1,
            marginEnd: 10,
            marginStart: 10,
        }}>
					<native_base_1.Image source={require("images/ic_shopping_cart.svg")} w={{
            base: 21,
            md: 35,
        }} h={{
            base: 21,
            md: 35,
        }} alt="shopping cart"/>
				</native_base_1.View>
				<native_base_1.Text style={{
            position: "absolute",
            minWidth: 25,
            height: 25,
            end: 0,
            top: 0,
            padding: 2,
            color: "white",
            backgroundColor: theme_1.Colors.colorVividRed1,
            borderRadius: 20,
            textAlign: "center",
            textAlignVertical: "center",
        }} variant="h5">
					{shoppingCartSize ?? "0"}
				</native_base_1.Text>
			</react_native_1.TouchableOpacity>
		</native_base_1.View>);
};
exports.ShoppingCartIndicator = ShoppingCartIndicator;
const ProductItem = ({ withBottomLine, first, product, addProduct, removeProduct, }) => {
    const navigation = (0, native_1.useNavigation)();
    const [productSize, setProductSize] = React.useState(() => {
        return product?.carrito || "";
    });
    const hangleProductSizeChange = (event) => {
        const newProductSize = event.target.value;
        //validamos si es un numero
        if (!isNaN(Number(newProductSize))) {
            setProductSize(newProductSize);
        }
        if (Number(newProductSize) == 0) {
            removeProduct(product);
        }
        else if (Number(newProductSize) > 0 && newProductSize != productSize)
            addProduct(product, newProductSize ?? 0);
    };
    const getStockTxt = () => {
        if ((0, url_1.getUserTypeFromUrl)() == constants_1.UserType.RV)
            return `${theme_1.Str.stock}: ${product?.stock ?? ""}`;
        else if ((0, url_1.getUserTypeFromUrl)() == constants_1.UserType.SN) {
            if ((Number(product?.stock ?? "0") ?? 0) > 0)
                return "Con stock";
            else
                return "Por agotarse";
        }
    };
    const onEyePress = () => {
        navigation.navigate("CatalogItemInfoName", {
            itemCode: product?.codigo,
        });
    };
    return (<native_base_1.View flexDirection="row" alignItems="center" borderColor={theme_1.Colors.colorLightGray1} borderBottomWidth={withBottomLine ? 2 : 0} borderTopLeftRadius={first ? theme_1.Sizes.configRadius : 0} borderTopRightRadius={first ? theme_1.Sizes.configRadius : 0} py={{ base: 15, md: 22 }} px={{ base: 15, md: 30 }} mx={{ base: 0, md: 40, lg: 70 }} mt={first ? 15 : 0} bg="white">
			<native_base_1.View flex="1" flexWrap="wrap" flexDirection="row" alignItems="center">
				<native_base_1.View style={{
            flex: 1,
        }}>
					<native_base_1.Text variant="h3">{product?.nombre || ""}</native_base_1.Text>
					<native_base_1.Text mt={{ base: 0, md: 2 }} variant="body5">
						{`SKU ${product?.codigo || ""}`}
					</native_base_1.Text>
					{product?.stockAlert == true && (<native_base_1.View background={`${product?.stockAlertColor}`} px={10} borderRadius={10} alignSelf="self-start">
							<native_base_1.Text mt={{ base: 0, md: 2 }} variant="body5">
								{`${product?.stockAlertReason ?? ""} ${product?.stockAlertFecha ?? ""}`}
							</native_base_1.Text>
						</native_base_1.View>)}
				</native_base_1.View>
				<native_base_1.VStack alignItems="center">
					<native_base_1.Pressable onPress={onEyePress}>
						<native_base_1.Image source={icons_1.default.icEye} w={20} h={20} padding={10} margin={10} style={{ tintColor: "black" }}/>
					</native_base_1.Pressable>
					<native_base_1.Text style={{
            backgroundColor: theme_1.Colors.colorVeryLightGray1,
            color: (Number(product?.stock ?? "0") ?? 0) > 0
                ? theme_1.Colors.colorLimeGreen1
                : theme_1.Colors.colorVividRed1,
            borderRadius: theme_1.Sizes.configRadius,
            paddingVertical: 3,
        }} mt="5" px={{
            base: 7,
            md: 13,
        }} variant="body6">
						{getStockTxt()}
					</native_base_1.Text>
				</native_base_1.VStack>
			</native_base_1.View>
			<native_base_1.Stack flexWrap="wrap" direction="row" mt={{ base: 10, lg: 0 }} justifyContent="space-between" alignItems="center">
				<native_base_1.Input value={productSize} placeholder="0" onChange={hangleProductSizeChange} style={{
            borderRadius: theme_1.Sizes.configRadiusSm,
            borderWidth: 2,
            borderColor: "black",
            fontFamily: theme_1.Fonts.bold,
            textAlign: "center",
        }} type="number" w={{
            base: 50,
            md: 60,
        }} fontSize="md" py={{ sm: 2, md: 8 }} px={{ sm: 2, md: 4 }} size={{ base: "xs", md: "md" }} mx={{ base: 10, lg: 40 }}/>
				<native_base_1.Box w={{
            base: 60,
            md: 79,
        }} alignItems="flex-end">
					<native_base_1.Text variant="h23">{product?.preciodescuento || ""}</native_base_1.Text>
					<native_base_1.Text strikeThrough mt={{ base: 0, md: 2 }} variant="body5">
						{product?.precio || ""}
					</native_base_1.Text>
					<native_base_1.Text variant="body5">{`DESC: ${product?.descuentofinal || ""}`}</native_base_1.Text>
				</native_base_1.Box>
			</native_base_1.Stack>
		</native_base_1.View>);
};
exports.ProductItem = ProductItem;
const BannerModal = () => {
    const [showModal, setShowModal] = React.useState(false);
    const [banner, setBanner] = React.useState();
    React.useEffect(() => {
        const getBanner = async () => {
            const response = await async_storage_1.default.getItem(constants_1.StorageKey.BANNER);
            if (response) {
                const url = response;
                setBanner(url);
                setShowModal(true);
            }
        };
        getBanner();
    }, []);
    const onCloseModal = () => {
        const removeBanner = async () => {
            await async_storage_1.default.removeItem(constants_1.StorageKey.BANNER);
            setBanner("");
            setShowModal(false);
        };
        removeBanner();
    };
    return <modal_1.ModalBanner source={{ uri: banner }} isOpen={showModal} onClose={onCloseModal}/>;
};
const DeudaModal = () => {
    const [showModal, setShowModal] = React.useState(false);
    const [message, setMessage] = React.useState();
    React.useEffect(() => {
        const getBanner = async () => {
            const response = await async_storage_1.default.getItem(constants_1.StorageKey.DEUDA);
            if (response) {
                setMessage(response);
                setShowModal(true);
            }
        };
        getBanner();
    }, []);
    const onCloseModal = () => {
        const removeBanner = async () => {
            await async_storage_1.default.removeItem(constants_1.StorageKey.DEUDA);
            setMessage("");
            setShowModal(false);
        };
        removeBanner();
    };
    return <modal_1.ModalDeuda message={message} isOpen={showModal} onClose={onCloseModal}/>;
};
const initialState = {
    query: "",
};
const reducer = (state) => {
    return {
        ...state,
    };
};
const stockStyles = react_native_1.StyleSheet.create({
    container: {
        minWidth: 100,
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        borderBottomColor: "black",
        borderBottomWidth: 2,
        paddingBottom: 10,
        marginEnd: 20,
    },
    imgMore: {
        marginStart: 10,
        width: 12,
        height: 12,
    },
});
exports.name = "OrdersName";
exports.default = OrdersPartial;
